<template>
  <router-view :style="darkmode ? $dark_theme : $light_theme" />
</template>

<script>
export default {
  name: "App",

  data: () => ({
    darkmode: false,
  }),
};
</script>
